import { storage } from '@/utils/storage';

/**
 * Vérifie si l'utilisateur a complété l'onboarding
 */
export function hasCompletedOnboarding(): boolean {
  return storage.getHasCompletedOnboarding();
}

/**
 * Marque l'onboarding comme complété
 */
export function markOnboardingComplete(): void {
  storage.setHasCompletedOnboarding(true);
}
